module.exports = __webpack_public_path__ + "img/synopsis_renyuan.e1110cd7.jpg";